export const EXCEL_EXTENSIONS = [
  'xlsx', 'xlsm', 'xls', 'xlsb',
  'xltx', 'xltm'
] as const;
